// Captures the browser's install prompt as early as possible so any "Install" button can trigger it later.
let deferred = null;
const listeners = new Set();
const notify = () => listeners.forEach((fn) => fn(deferred));

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => { e.preventDefault(); deferred = e; notify(); });
  window.addEventListener('appinstalled', () => { deferred = null; notify(); });
}

export const isStandalone = () => window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
export const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;
export const getInstallPrompt = () => deferred;
export const onInstallPromptChange = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };
export const triggerInstall = async () => {
  if (!deferred) return 'unavailable';
  deferred.prompt();
  const { outcome } = await deferred.userChoice;
  if (outcome === 'accepted') { deferred = null; notify(); }
  return outcome;
};
